<template>
    <div class="component">
        <div class="main-title">
            <div class="square"></div>
            <div class="title-content">能力素养</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TabAbility",
        props: {
            componentData: [Object, Array]
        },
        mounted() {
            console.log(componentData)
        },
        methods: {},
        data() {
            return {};
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

</style>
